import { Box, IconButton, Typography } from "@mui/material";
import { green, grey } from "@mui/material/colors";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { useBreakpoints } from "../../../../hooks/useBreakpoins";
import { colors } from "../../../../theme/colors";
import { useNavigate } from "react-router-dom";
import { Logo } from "../../../layouts/Logo";
interface Props {
  infoColor?: string;
}

export function ContactInfo({ infoColor = colors.textGrey[500] }: Props) {
  const nav = useNavigate();
  const { isMobile, isSmalldesktop } = useBreakpoints();
  const textAlpha = colors.textAlpha[500];
  return (
    <Box
      width={"100%"}
      display={"flex"}
      justifyContent={"space-between"}
      flexWrap={"wrap"}
      zIndex={500}
    >
      <Box
        display={"flex"}
        justifyContent={"flex-start"}
        flexWrap={"wrap"}
        gap={3}
      >
        <Box>
          <Box display={"flex"} gap={1} ml={2} p={1}>
            <IconButton
              sx={{
                background: green[500],
                "&: hover": { background: green[100] },
                width: 40,
                height: 40,
              }}
            >
              <a
                href="https://api.whatsapp.com/send?phone=5516994619371"
                target="_blank"
                rel="noreferrer"
                style={{ marginBottom: -5 }}
              >
                <WhatsAppIcon style={{ fill: "#FFF" }} />
              </a>
            </IconButton>

            <IconButton
              sx={{
                background: "#FFF",
                "&: hover": { background: grey[300] },
                width: 40,
                height: 40,
              }}
            >
              <a
                href="https://www.instagram.com/lojacoelhomagico"
                target="_blank"
                rel="noreferrer"
                style={{ marginBottom: -5 }}
              >
                <InstagramIcon
                  style={{
                    fill: "#FFF",
                    background:
                      "radial-gradient(circle farthest-corner at 35% 90%, #fec564, transparent 50%), radial-gradient(circle farthest-corner at 0 140%, #fec564, transparent 50%), radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%), radial-gradient(ellipse farthest-corner at 20% -50%, #5258cf, transparent 50%), radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%), radial-gradient(ellipse farthest-corner at 60% -20%, #893dc2, transparent 50%), radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent), linear-gradient(#6559ca, #bc318f 30%, #e33f5f 50%, #f77638 70%, #fec66d 100%)",
                    borderRadius: 5,
                  }}
                />
              </a>
            </IconButton>
          </Box>

          <Box
            sx={{
              borderRadius: 2,
              p: 2,
              mt: isMobile ? 2 : 0,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {/* <Box>
              <ApartmentIcon />

              <Typography color={colors.textGrey[600]} fontWeight={700}>
                Rua Anne Frank, 839 - Boqueirão
              </Typography>
              <Typography color={colors.textGrey[500]}>
                Curitiba - PR | 83240-240
              </Typography>
            </Box> */}

            <Typography color={colors.textGrey[500]}>
              <LocalPhoneIcon sx={{ marginBottom: -1, mr: 1 }} />
              <span>+55 (16) 99461-9371</span>
            </Typography>
          </Box>
        </Box>

        <Box display={"flex"} flexDirection={"column"} gap={3} p={2}>
          {/* <Typography
            display={"flex"}
            alignItems={"center"}
            color={infoColor}
            sx={{
              cursor: "pointer",
              width: 268,
              "&:hover": { color: textAlpha },
            }}
            onClick={() => nav("/about-us")}
          >
            <ApartmentIcon style={{ fill: infoColor, marginRight: 10 }} />
            Notation based on the Specific Commercial Transactions Law
          </Typography>

          <Typography
            display={"flex"}
            alignItems={"center"}
            color={infoColor}
            sx={{
              cursor: "pointer",
              width: 268,
              "&:hover": { color: textAlpha },
            }}
            onClick={() => nav("/terms-and-conditions")}
          >
            <AssignmentIcon style={{ fill: infoColor, marginRight: 10 }} />
            Termos e condições
          </Typography> */}

          <Typography
            display={"flex"}
            alignItems={"center"}
            color={infoColor}
            sx={{
              width: 268,
            }}
          >
            Tem alguma dúvida? Entre em contato conosco!
          </Typography>
          <Typography
            display={"flex"}
            alignItems={"center"}
            color={infoColor}
            sx={{
              cursor: "pointer",
              width: 268,
              "&:hover": { color: textAlpha },
            }}
            onClick={() => nav("/contact?tab=3")}
          >
            <ContactMailIcon style={{ fill: infoColor, marginRight: 10 }} />
            Suporte
          </Typography>
          {/* <Typography
            display={"flex"}
            alignItems={"center"}
            color={infoColor}
            sx={{
              cursor: "pointer",
              width: 268,
              "&:hover": { color: textAlpha },
            }}
            onClick={() => nav("/privacy-policy")}
          >
            <AdminPanelSettingsIcon
              style={{ fill: infoColor, marginRight: 10 }}
            />
            Política de privacidade
          </Typography> */}
        </Box>
      </Box>
      <Box
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        mr={5}
        width={isSmalldesktop ? "100%" : "auto"}
      >
        <Logo onClick={() => nav("/home")} />
      </Box>
    </Box>
  );
}
